var React = require('react');

function Flourish (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"st0","d":"M53.9,0.6h0.4l0.3,0.3c6,6,11.9,11.9,17.9,17.9c6-6,11.9-11.9,17.9-17.9l0.3-0.3H91l0,0h-0.4l-0.3,0.3\n\tc-6,6-11.9,11.9-17.9,17.9c-6-6-11.9-11.9-17.9-17.9l-0.3-0.3L53.9,0.6L53.9,0.6z","key":0}),React.createElement("polygon",{"className":"st1","points":"140.7,0.8 137.7,3.8 78.3,3.8 72.3,9.3 66.2,3.8 6.9,3.8 3.8,0.8 0.4,0.8 0,1.2 5.6,6.8 65,6.8 \n\t72.3,13.4 79.5,6.8 138.9,6.8 144.5,1.2 144.1,0.8 ","key":1})]);
}

Flourish.defaultProps = {"version":"1.1","id":"Layer_1_copy","x":"0px","y":"0px","viewBox":"0 0 144.5 19.6","style":{"enableBackground":"new 0 0 144.5 19.6"},"xmlSpace":"preserve"};

module.exports = Flourish;

Flourish.default = Flourish;
